
export const displayUserResearchChoiceSelector = ({displayUserResearchChoice}) => displayUserResearchChoice